import React from "react";
import LootLedgerLogo from "../../../assets/images/lootLedgerLogo.svg";

const SidebarFooter = () => {
  return (
    <div className="mt-auto d-flex justify-content-center align-items-center sidebar-footer-wrapper">
      <img
        src={LootLedgerLogo}
        alt="loot-ledger-logo"
        className="loot-ledger-footer-logo"
      />
    </div>
  );
};

export default SidebarFooter;
